import { request, success, failure, USER_LIST_REQUEST } from "./utilities";
import { getAllUserList } from "../api";
import { Users } from "../../utils/dummyData";

export function getUserList() {
    return (dispatch) => {
        dispatch(request(USER_LIST_REQUEST.GET_USER_REQUEST));
        
        dispatch(success(USER_LIST_REQUEST.GET_USER_SUCCESS, Users))
        // getAllUserList().then(
        //     response => {
        //         if (response.data.status === 1) {
        //             dispatch(success(USER_LIST_REQUEST.GET_USER_SUCCESS, response.data.data))
        //         }
        //         else {
        //             dispatch(failure(USER_LIST_REQUEST.GET_USER_FAILURE, response.data.message))
        //         }
        //     },
        //     error => {
        //         dispatch(failure(USER_LIST_REQUEST.GET_USER_FAILURE, (error && error.response && error.response.data && error.response.data.title ? error.response.data.title : error.message)))
        //     }
        // )
    }
}